<script lang="ts">
	import { fade } from 'svelte/transition'

	interface Props {
		onclick?: (event: Event) => void
	}

	let { onclick }: Props = $props()
</script>

<div
	class="absolute h-full w-full bg-black/40 backdrop-blur-xs"
	aria-hidden="true"
	{onclick}
	transition:fade|local={{ duration: 200 }}
></div>
